// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Label from "../../primitives/Label.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderConditionAndNotesCard(props) {
  let state = OrderEditForm.useFormState();
  let tmp;
  if (props.editable) {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(OrderEditForm.InputTextArea.make, {
          field: "Condition",
          label: I18n.t("Conditions")
        }),
        JsxRuntime.jsx(OrderEditForm.InputTextArea.make, {
          field: "NoteForSupplier",
          label: I18n.t("Supplier note")
        })
      ]
    });
  } else {
    let condition = state.values.condition;
    let noteForSupplier = state.values.noteForSupplier;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsxs(Box.make, {
          children: [
            JsxRuntime.jsx(Label.make, {
              text: I18n.t("Conditions")
            }),
            condition.length > 0 ? JsxRuntime.jsx(TextStyle.make, {
                children: condition,
                size: "large"
              }) : JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Empty condition"),
                variation: "subdued"
              })
          ],
          spaceTop: "xsmall"
        }),
        JsxRuntime.jsxs(Box.make, {
          children: [
            JsxRuntime.jsx(Label.make, {
              text: I18n.t("Supplier note")
            }),
            noteForSupplier.length > 0 ? JsxRuntime.jsx(TextStyle.make, {
                children: noteForSupplier,
                size: "large"
              }) : JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Empty note"),
                variation: "subdued"
              })
          ],
          spaceTop: "xsmall"
        })
      ]
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: tmp,
    title: "Notes"
  });
}

let make = React.memo(OrderConditionAndNotesCard);

export {
  make,
}
/* make Not a pure module */
